import "@tamagui/core/reset.css";
import "~/i18n";
import "~/sentry.config";
import "../tamagui-web.css";
import "../utils/patch-animated";

import { Suspense, useEffect } from "react";
import { Slot, SplashScreen, usePathname } from "expo-router";
import Hotjar from "@hotjar/browser";
import { BuildVersionWatcher } from "@ptsd/uikit";
import * as Sentry from "@sentry/react-native";
import { ToastProvider, ToastViewport } from "@tamagui/toast";
import { TamaguiProvider } from "tamagui";

import { TRPCProvider } from "~/utils/api";
import { GlobalErrorScreen } from "~/components/blocks/global-error-screen";
import { AppToast } from "~/components/layout";
import env from "../config";
import config from "../tamagui.config";

void SplashScreen.preventAutoHideAsync();

export default function Layout() {
  const pathname = usePathname();

  useEffect(() => {
    if (env.HOT_JAR_SITE_ID !== undefined && env.HOTJAR_VERSION !== undefined) {
      Hotjar.init(env.HOT_JAR_SITE_ID, env.HOTJAR_VERSION);
    }
  }, []);

  useEffect(() => {
    if (Hotjar.isReady()) {
      Hotjar.stateChange(pathname);
    }
  }, [pathname]);

  return (
    <TRPCProvider>
      <TamaguiProvider config={config} defaultTheme={"light"}>
        <ToastProvider>
          <BuildVersionWatcher buildCreatedAt={env.BUILD_CREATED_AT} />
          <Sentry.ErrorBoundary
            fallback={({ error }) => (
              <GlobalErrorScreen error={error.message} />
            )}
          >
            <AppWithSentry />
          </Sentry.ErrorBoundary>
          <AppToast />
          <ToastViewport bottom={"$4"} left={0} right={0} />
        </ToastProvider>
      </TamaguiProvider>
    </TRPCProvider>
  );
}

const App = () => {
  const pathname = usePathname();

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Suspense>
      <Slot />
    </Suspense>
  );
};

const AppWithSentry = Sentry.wrap(App);
